export const Pagination = 'atlantis-pagination';
